import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PaginationParams, RecentTasks as CanCompleteTask } from '../tasks';
import { TaskService } from '../task.service';
import { GlobalService } from './../../core/';
import { GlobalNamespace as _GlobalNS } from './../../../environments/environment';
import * as _ from 'lodash';

@Component({
  selector: 'app-assigned-tasks',
  templateUrl: './assigned-tasks.component.html',
  styleUrls: ['./assigned-tasks.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AssignedTasksComponent implements OnInit {
  overView: true;
  paginationParams: PaginationParams = { Offset: 0, PageSize: 10, SortValue: 'TaskStatusId', SortDir: 'Asc' };
  loading = false;
  totalRecords = 0;
  taskToComplete: CanCompleteTask[];
  taskSelected: CanCompleteTask;
  dashboardTitle = '';
  title = '';
  clickableHeader = true;
  showPaginator = false;
  constructor(
    private taskSvc: TaskService
    , private _global: GlobalService
  ) { }

  ngOnInit() {
    this.overView = this._global.find((<any>_GlobalNS).paths.OverView);
    this.loading = true;
    this.loadData();
    this.initData();
  }

  initData(): void {
    if (this.overView) {
      this.clickableHeader = true;
      this.showPaginator = false;
    } else {
      this.clickableHeader = false;
      this.showPaginator = true;
    }
  }

  getPropertyViewUri(PropertyId: number): string {
    return this.taskSvc.getPropertyViewUri(PropertyId);
  }

  getTaskViewUri(eventlocation: string, property_id: number,
    eventTrackingID: number, event_tracking_parent?: number): string {
    return this.taskSvc.getTaskViewUri(eventlocation, property_id, eventTrackingID, event_tracking_parent);
  }

  displayAddress(op, event, source): void {
    this.taskSelected = source;
    op.show(event);
  }

  navigateUri(event): void {
    const workflowURL = `${(<any>_GlobalNS).routes.workflow.myCompletableTasks}`;
    this._global.document.location.href = workflowURL;
  }

  /* sevice call to get data*/
  loadData() {
    this.loading = true;
    this.taskSvc.findByPerson(this.paginationParams, true)
      .subscribe((canCompleteTask: CanCompleteTask[]) => {
        const taskToCompleteCurrentPage = (<any>canCompleteTask).data;
        this.taskToComplete = taskToCompleteCurrentPage;
        this.totalRecords = (<any>canCompleteTask).meta.pagination.TotalRecords;
        this.dashboardTitle = `Task Workflow(${this.totalRecords})`;
        this.title = (this.overView ? '' : `Task Workflow(${this.totalRecords})`);
        this.loading = false;
      });
  }

  /* set pagination / sort parameters
  and load paginated data  */
  loadPaginatedData(event): void {
    this.paginationParams = {
      Offset: (event.first !== undefined ? event.first : this.paginationParams.Offset)
      , PageSize: (event.rows !== undefined ? event.rows : this.paginationParams.PageSize)
      , SortDir: (event.sortOrder === 1 || event.sortOrder === 'Asc') ? 'Asc' : 'Desc'
      , SortValue: event.sortField ? event.sortField : 'DueDate'
    };
    this.overView ? this.overViewLoadData() : this.loadData();
  }

  /*loading data for  overview page and sorting */
  overViewLoadData(): void {
    this.paginationParams.SortValue = this.paginationParams.SortValue.toLocaleLowerCase()
                                      === 'propertyaddressstate' ? 'Address.State' :  this.paginationParams.SortValue;
    this.taskToComplete = _.orderBy(this.taskToComplete, [this.paginationParams.SortValue], [this.paginationParams.SortDir.toLowerCase()]);
  }
}